import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

import { ErrorMonitoringService } from "@/shared/services";
import { actions, useVizDispatch } from "@/shared/state/visualization";
import { LegendPosition } from "@/shared/state/visualization/schema";

import styles from "./SelectLegendPosition.module.css";

interface SelectLegendPositionProps {
  panelId: string;
  legendPosition: LegendPosition;
}

const LegendPositionLabels: Record<LegendPosition, string> = {
  [LegendPosition.TopLeft]: "Top Left",
  [LegendPosition.TopRight]: "Top Right",
  [LegendPosition.BottomLeft]: "Bottom Left",
  [LegendPosition.BottomRight]: "Bottom Right",
};

export function SelectLegendPosition({
  panelId,
  legendPosition,
}: SelectLegendPositionProps) {
  const dispatch = useVizDispatch();

  const onLegendPositionChange = (event: SelectChangeEvent) => {
    try {
      dispatch(
        actions.setPlotPanelConfig(panelId, {
          legendPosition: event.target.value as LegendPosition,
        }),
      );
    } catch (err) {
      ErrorMonitoringService.captureError(err);
    }
  };

  return (
    <FormControl className={styles.container} fullWidth>
      <Select
        labelId="legend-position-label"
        id="legend-position-select"
        value={legendPosition}
        onChange={onLegendPositionChange}
        size="small"
        className={styles.smallFont}
      >
        {Object.values(LegendPosition).map((value) => (
          <MenuItem key={value} value={value} className={styles.smallFont}>
            {LegendPositionLabels[value]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
